const AIRWALLEX_COMPONENTS_SDK_URL = 'https://static.airwallex.com/components/sdk/v1/index.js';

export type AirwallexComponentsSdkInit = {
  elements: string[];
  authCode: string;
  codeVerifier: string;
  langKey?: string;
  /** 'demo' for sandbox, 'prod' for live. Must match the environment that minted the auth code. */
  env?: string;
  clientId?: string;
};

export type AirwallexComponentsSdkElement = {
  mount: (el: HTMLElement) => void;
  unmount?: () => void;
  on?: (event: string, cb: (event?: unknown) => void) => void;
};

export type AirwallexComponentsSdk = {
  init: (options: AirwallexComponentsSdkInit) => Promise<void>;
  createElement: (
    type: string,
    options?: { hideHeader?: boolean; hideNav?: boolean },
  ) => Promise<AirwallexComponentsSdkElement>;
};

/** Loads the Airwallex components SDK once per page and returns the global it installs. */
export async function loadAirwallexComponentsSdk(): Promise<AirwallexComponentsSdk> {
  const globalSdk = () =>
    (window as unknown as { AirwallexComponentsSDK?: AirwallexComponentsSdk }).AirwallexComponentsSDK;

  if (!globalSdk()) {
    await new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = AIRWALLEX_COMPONENTS_SDK_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Airwallex Components SDK'));
      document.head.appendChild(script);
    });
  }

  const sdk = globalSdk();
  if (!sdk) {
    throw new Error('Airwallex Components SDK failed to load.');
  }
  return sdk;
}
